<template>
  <div class="wrapper">
    <div class="content-7">
      <lottery-item
        :lottery-code="cpType"
        @drawing="drawing($event)"
        @complete="complete($event)"
        @timeChange="timeChange($event)"
      />
    </div>

    <div class="content-8">
      <div class="content-8__titlebar">
        <div class="content-8__titlebar__left">
          <div class="c8-titlename"><span class="c8-titlename__text">竞猜中心</span></div>
          <div class="c8-menubox">
            <div class="menubar">
              <div class="menubar__itembox">
                <div v-for="link in menuList" :key="link.value" class="menubar__item" :class="{'active':currentMenu === link.value}" @click.prevent="menuRoute(link)">
                  <span class="menubar__item__text">{{ link.label }}</span>
                  <div class="menubar__item__lightborder"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-8__titlebar__right">
          <div class="fn-wrap">
            <a class="button-outline c8-datebox__item" @click.prevent="openDescription">
              <span class="button-outline__text">帮助说明</span>
            </a>
          </div>
          <div class="c8-datebox">
            <a :class="{'disable':hasSignIn}" class="button-outline active c8-datebox__item" href="" @click.prevent="signIn">
              <span class="button-outline__text">{{ hasSignIn ? '今日已签到' :'签到' }}</span>
            </a>
            <a class="button-outline c8-datebox__item fn-post" :class="{'disable':hasPrediciton || stopPrediction}" href="" @click.prevent="postBet">
              <span class="button-outline__text">{{ postButtonText }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div>
      <nuxt-child :cp-type="cpType" :has-prediciton="hasPrediciton" :lottery-info="lotteryInfo" :update-my-lottery-bet="updateMyLotteryBet" @showPopup="showPopup" @setUpdateMyLotteryBet="setUpdateMyLotteryBet" />
    </div>
    <betPicker v-if="showBetPicker" :timer="timer" :lottery-info="lotteryInfo" :show-bet-picker="showBetPicker" @hidePopup="hidePopup" @checkHasPrediction="checkHasPrediction" @setUpdateMyLotteryBet="setUpdateMyLotteryBet" />
  </div>
</template>

<script>
import betPicker from '@/components/web/pages/betLottery/BetPicker'
import * as moment from 'moment-mini'
import LotteryItem from '@/components/web/pages/trend/LotteryItem'
import { getUserInfo_mobile } from '@/api/mobile/member'
import { signIn_mobile } from '@/api/mobile/betLottery'
import { checkIsLogin_web } from '@/utils/member'
import { checkPrediction_mobile } from '@/api/mobile/betLottery'
export default {
  layout: 'default',
  name: 'LotteryHomeWeb',
  components: {
    betPicker,
    LotteryItem
  },
  data() {
    return {
      firstTimeFlag: true,
      updateMyLotteryBet: false,
      childPopup: false,
      stopPrediction: false,
      hasPrediciton: '',
      timer: '',
      lotteryInfo: {},
      showBetPicker: false,
      hasSignIn: false,
      signInDate: '',
      cpType: this.$route.params.lottery_code,
      currentMenu: 'rank',
      menuList: [
        {
          value: 'rank',
          label: '排行榜'
        },
        {
          value: 'newlotterybet',
          label: '最新竞猜'
        },
        {
          value: 'mylotterybet',
          label: '我的竞猜'
        },
        {
          value: 'mysubscription',
          label: '我的订阅'
        }
      ]
    }
  },
  computed: {
    postButtonText() {
      let val
      if (!this.lotteryInfo.nextPeriod) {
        val = '停开中'
      } else if (this.stopPrediction) {
        val = '开奖中...'
      } else if (this.hasPrediciton) {
        val = '本期已发'
      } else if (!this.hasPrediciton) {
        val = '发布竞猜'
      }
      return val
    }
  },
  watch: {
    timer(val) {
      if (val === '开奖中...') {
        this.stopPrediction = true
      } else {
        this.stopPrediction = false
      }
    },
    $route(to, from) {
      this.currentMenu = to.fullPath.split('/')[4]
      this.cpType = this.$route.params.lottery_code
    }
  },
  async mounted() {
    this.cpType = this.$route.params.lottery_code
    const date = moment().format('DD')
    this.currentMenu = this.$route.fullPath.split('/')[4]
    const [data, error] = await getUserInfo_mobile()
    if (error) return
    this.hasSignIn = moment(data.lastSigninAt).format('DD') === date
  },
  methods: {
    openDescription() {
      this.$store.commit('lottery/OPEN_DESCRIPTION', { name: '帮助说明', lotteryCode: '', descriptionType: 'prediction' })
    },
    setUpdateMyLotteryBet(val) {
      this.updateMyLotteryBet = val
    },
    showPopup(val) {
      this.childPopup = val
    },
    async menuRoute(link) {
      if (link.value === 'mylotterybet' || link.value === 'mysubscription') {
        if (await checkIsLogin_web(this)) {
          this.$router.push(`/lotterybet/lotteryhome/${this.cpType}/${link.value}`)
        }
      } else {
        this.$router.push(`/lotterybet/lotteryhome/${this.cpType}/${link.value}`)
      }
    },
    async checkPrediction() {
      const [data, error] = await checkPrediction_mobile({ cpCode: this.cpType, period: this.lotteryInfo.nextPeriod.period })
      if (error) return
      this.hasPrediciton = data
    },
    checkHasPrediction(val) {
      this.hasPrediciton = val
    },
    changeLottery(val) {
      const target = this.$route.path.split('/')
      target[4] = val
      const path = target.join('/')
      this.$router.push(path)
    },
    timeChange(time) {
      this.timer = time
    },
    drawing(drawing) {
      // console.log('drawing: ', drawing)
    },
    complete(complete) {
      this.lotteryInfo = complete
      this.hasPrediciton = false
      if (!this.firstTimeFlag) {
        this.updateMyLotteryBet = true
      }
      if (this.lotteryInfo.nextPeriod) {
        this.checkPrediction()
      }
      this.firstTimeFlag = false
    },
    hidePopup(val) {
      this.showBetPicker = val
    },
    async signIn() {
      const _this = this
      if (this.hasSignIn) return
      if (await checkIsLogin_web(this)) {
        const [data, error] = await signIn_mobile()
        if (error) return
        console.log(data)
        this.$msgbox('签到成功', '提示', {
          confirmButtonText: '确定'
        }).then(action => {
          _this.hasSignIn = true
        }).catch(err => {
          console.log(err)
          _this.hasSignIn = true
        })
      }
    },
    async postBet() {
      if (this.hasPrediciton || this.stopPrediction || Object.keys(this.lotteryInfo).length === 0 || !this.lotteryInfo.nextPeriod) return
      if (checkIsLogin_web(this)) {
        this.showBetPicker = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fn-post {
  color: #178AFF;
  box-shadow: inset 0 0 0 1px #178AFF;
}
.fn-wrap {
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: 16px;
  margin-right: 16px;
  border-right:solid 1px #EBEBEB
}
</style>
